import React from 'react';
import { Link } from 'react-router-dom';
import {
    EnvelopeIcon,
    PhoneIcon,
    MapPinIcon,
    ShareIcon,
    GlobeAltIcon,
    ChatBubbleLeftRightIcon,
    NewspaperIcon
} from '@heroicons/react/24/outline';

const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="bg-primary text-light">
            <div className="container mx-auto px-4 py-12">
                <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
                    {/* Company Info */}
                    <div>
                        <h3 className="text-2xl font-serif mb-4">Parth Interiors</h3>
                        <p className="text-light/80">
                            Creating timeless and innovative designs for your dream space.
                        </p>
                    </div>

                    {/* Quick Links */}
                    <div>
                        <h4 className="text-lg font-serif mb-4">Quick Links</h4>
                        <ul className="space-y-2">
                            <li>
                                <Link to="/" className="text-light/80 hover:text-accent transition-colors duration-300">
                                    Home
                                </Link>
                            </li>
                            <li>
                                <Link to="/projects" className="text-light/80 hover:text-accent transition-colors duration-300">
                                    Projects
                                </Link>
                            </li>
                            <li>
                                <Link to="/services" className="text-light/80 hover:text-accent transition-colors duration-300">
                                    Services
                                </Link>
                            </li>
                            <li>
                                <Link to="/about" className="text-light/80 hover:text-accent transition-colors duration-300">
                                    About
                                </Link>
                            </li>
                            <li>
                                <Link to="/contact" className="text-light/80 hover:text-accent transition-colors duration-300">
                                    Contact
                                </Link>
                            </li>
                        </ul>
                    </div>

                    {/* Contact Info */}
                    <div>
                        <h4 className="text-lg font-serif mb-4">Contact Us</h4>
                        <ul className="space-y-4">
                            <li className="flex items-center text-light/80">
                                <EnvelopeIcon className="w-5 h-5 mr-2" />
                                <a href="mailto:info@parthinteriors.com" className="hover:text-accent transition-colors duration-300">
                                    info@parthinteriors.com
                                </a>
                            </li>
                            <li className="flex items-center text-light/80">
                                <PhoneIcon className="w-5 h-5 mr-2" />
                                <a href="tel:+1234567890" className="hover:text-accent transition-colors duration-300">
                                    +1 234 567 890
                                </a>
                            </li>
                            <li className="flex items-center text-light/80">
                                <MapPinIcon className="w-5 h-5 mr-2" />
                                123 Design Street, City
                            </li>
                        </ul>
                    </div>

                    {/* Social Links */}
                    <div>
                        <h4 className="text-lg font-serif mb-4">Follow Us</h4>
                        <div className="flex space-x-4">
                            <a
                                href="https://facebook.com/parthinteriors"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-light/80 hover:text-accent transition-colors duration-300"
                                aria-label="Facebook"
                            >
                                <ShareIcon className="w-6 h-6" />
                            </a>
                            <a
                                href="https://instagram.com/parthinteriors"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-light/80 hover:text-accent transition-colors duration-300"
                                aria-label="Instagram"
                            >
                                <GlobeAltIcon className="w-6 h-6" />
                            </a>
                            <a
                                href="https://twitter.com/parthinteriors"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-light/80 hover:text-accent transition-colors duration-300"
                                aria-label="Twitter"
                            >
                                <ChatBubbleLeftRightIcon className="w-6 h-6" />
                            </a>
                            <a
                                href="https://linkedin.com/company/parthinteriors"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-light/80 hover:text-accent transition-colors duration-300"
                                aria-label="LinkedIn"
                            >
                                <NewspaperIcon className="w-6 h-6" />
                            </a>
                        </div>
                    </div>
                </div>

                {/* Copyright */}
                <div className="border-t border-light/20 mt-8 pt-8 text-center text-light/60">
                    <p>&copy; {currentYear} Parth Interiors. All rights reserved.</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer; 